<img src="assets/images/logo-smart.png" class="logo" >

<h3 id="title" class="title">{{ 'tytul.resetowanie-hasla' | translate }}</h3>

<p class="sub-title">{{ 'etykieta.resetuj-haslo' | translate }}</p>

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>{{ 'komunikat.blad.domyslny' | translate }}!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<form (ngSubmit)="requestPass()" #requestPassForm="ngForm" aria-labelledby="title">

  <div class="form-control-group">
    <label class="label" for="input-email">{{ 'etykieta.podaj-adres-email' | translate }}:</label>
    <input nbInput
           [(ngModel)]="user.email"
           #email="ngModel"
           id="input-email"
           name="email"
           pattern=".+@.+\..+"
           placeholder="E-mail"
           autofocus
           fullWidth
           fieldSize="large"
           [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="getConfigValue('forms.validation.email.required')"
           [attr.aria-invalid]="email.invalid && email.touched ? true : null">
    <ng-container *ngIf="email.invalid && email.touched">
      <p class="caption status-danger" *ngIf="email.errors?.required">
        {{ 'komunikat.blad.email-jest-wymagany' | translate }}!
      </p>
      <p class="caption status-danger" *ngIf="email.errors?.pattern">
        {{ 'komunikat.blad.email-niepoprawny' | translate }}!
      </p>
    </ng-container>
  </div>

  <button nbButton
          fullWidth
          status="primary"
          size="large"
          [disabled]="submitted || !requestPassForm.valid"
          [class.btn-pulse]="submitted">
    {{ 'akcja.resetuj-haslo' | translate }}
  </button>
</form>

<section class="sign-in-or-up" aria-label="Zaloguj lub zarejestruj">
  <p><a class="text-link" routerLink="../login">{{ 'etykieta.powrot-do-logowania' | translate }}</a></p>
  <p><a class="text-link" routerLink="../register">{{ 'etykieta.rejestracja' | translate }}</a></p>
</section>

<section class="another-action">
  <ngx-wybor-jezyka-panel></ngx-wybor-jezyka-panel>
</section>